<template>
  <v-form ref="form" v-model="isValid" lazy-validation>
    <v-select
      v-model="selectedReasonId"
      outlined
      clearable
      validate-on-blur
      item-text="description"
      item-value="id"
      hide-details="auto"
      :placeholder="`${$t('tables.noneSelected')}`"
      :label="`${ $t('titles.reason') }:`"
      :rules="[rules.required]"
      :items="displayedReasons"
      :loading="loading"
      @change="emitReason()"
    />
    <v-text-field
      v-if="reasonOtherSelected && isFreeTextCorrectionReasonsActive"
      v-model="otherReason"
      outlined
      label="Please specify the reason:"
      class="mt-5"
      @change="emitReason()"
    />
  </v-form>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';

import validatable from '@/mixins/validatable';
import constants from '@/constants';

import hasTimePairFeatures from '@/mixins/timepairs/hasTimePairFeatures';

export default {
  name: 'ReasonCard',

  mixins: [validatable, hasTimePairFeatures],

  props: {
    value: Boolean,
    filter: String,
  },

  data() {
    return {
      selectedReasonId: null,
      loading: false,
      otherReason: null,
    };
  },

  computed: {
    ...mapState(['correctionReasons']),

    displayedReasons() {
      if (!isEmpty(this.filter)) {
        return filter(
          this.correctionReasons,
          (reason) => reason.description.toLowerCase().indexOf(this.filter.toLowerCase()) === -1,
        );
      }
      return this.correctionReasons;
    },

    reasonOtherSelected() {
      return this.selectedReasonId === constants.REASON_IDS.OTHER_ID;
    },
  },

  watch: {
    value() {
      if (!this.value) {
        this.selectedReasonId = null;
      }
    },
  },

  methods: {
    ...mapActions(['loadCorrectionReasons']),

    emitReason() {
      if (this.otherReason === null || this.otherReason === '') {
        this.$emit('change', { id: this.selectedReasonId, description: null });
      } else {
        this.$emit('change', { id: null, description: this.otherReason });
      }
    },
  },

  created() {
    this.loading = true;
    this.loadCorrectionReasons().finally(() => {
      this.loading = false;
    });
  },
};
</script>
